import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";


const styles = StyleSheet.create({
  title: {
  fontSize: 16,
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: 20,
},
page: {
  padding: 30,
  fontSize: 11,
  lineHeight: 1.5,
},
section: {
  marginBottom: 12,
},
label: {
  fontWeight: "bold",
},
tableHeader: {
  flexDirection: "row",
  borderBottom: 1,
  marginBottom: 4,
  paddingBottom: 2,
},
row: {
  flexDirection: "row",
  borderBottom: "1px solid #eee",
  paddingVertical: 4,
},
col: {
  width: "33%",
},
thankYou: {
  fontSize: 12,
  fontWeight: "bold",
  textAlign: "center",
  marginTop: 20,
},
});

const DeliveryPDF = ({ data }) => {
  const {
    deliveryId,
    deliveredDate,
    customerName,
    customerAddress,
    contactPerson,
    contactNumber,
    paymentMode,
    repName,
    salesOrder,
    deliveryProducts = [],
  } = data;

  console.log(salesOrder,"salesOrder");
  

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          <Text style={styles.title}>
            Delivery Receipt
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Delivery ID: </Text>
          <Text>{deliveryId}</Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Delivered Date: </Text>
          <Text>{deliveredDate}</Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Customer: </Text>
          <Text>{customerName} - {customerAddress}</Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Contact: </Text>
          <Text>{contactPerson} - {contactNumber}</Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Delivery Name: </Text>
          <Text>{repName}</Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Sales Order: </Text>
          <Text>{salesOrder?.soNumber}</Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.label}>Payment Mode: </Text>
          <Text>{paymentMode}</Text>
        </View>

        <View style={[styles.section, styles.tableHeader]}>
          <Text style={styles.col}>Product Code</Text>
          <Text style={styles.col}>Product Name</Text>
          <Text style={styles.col}>Quantity</Text>
        </View>

        {deliveryProducts.map((prod, idx) => (
          <View style={styles.row} key={idx}>
            <Text style={styles.col}>{prod.productCode}</Text>
            <Text style={styles.col}>{prod.productName}</Text>
            <Text style={styles.col}>{prod.quantity}</Text>
          </View>
        ))}
        <View style={styles.section}>
          <Text style={styles.thankYou}>Thank You for your Purchase! </Text>
        </View>
      </Page>
    </Document>
  );
};

export default DeliveryPDF;
